<template>
  <div>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Oficio CORE</h2>
      <div class="row form-group">
        <label for="sender" class="col-3 col-form-label">De</label>
        <div class="col-4">
          <b-form-input
            :state="errors.has('custom-document.sender') ? false : null"
            data-cy="sender"
            data-vv-as="DE"
            name="sender"
            type="text"
            v-model="formData.sender"
            v-validate="'required'"
          />
          <div
            v-if="errors.has('custom-document.sender')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
              <span class="span-text-validation">
                {{ errors.first('custom-document.sender') }}
              </span>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label for="receiver" class="col-3 col-form-label">A</label>
        <div class="col-4">
          <b-form-input
            :state="errors.has('custom-document.receiver') ? false : null"
            data-cy="receiver"
            data-vv-as="A"
            name="receiver"
            type="text"
            v-model="formData.receiver"
            v-validate="'required'"
          />
          <div
            v-if="errors.has('custom-document.receiver')"
            class="con-text-validation span-text-validation-danger v-enter-to"
          >
              <span class="span-text-validation">
                {{ errors.first('custom-document.receiver') }}
              </span>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <label for="receiver" class="col-3 col-form-label">Cargo</label>
        <div class="col-4">
          <b-form-input
            data-cy="position"
            data-vv-as="position"
            name="position"
            type="text"
            v-model="formData.position"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Antecedentes">
            <b-form-textarea
              data-cy="background"
              name="background"
              maxLength="500"
              rows="3"
              type="text"
              v-model="formData.background"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{formData.background.length}}/500
              </small>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Materia *">
            <b-form-textarea
              :state="errors.has('custom-document.matter') ? false : null"
              data-cy="matter"
              data-vv-as="materia"
              name="matter"
              maxLength="500"
              rows="3"
              type="text"
              v-model="formData.matter"
              v-validate="'required'"
            />
            <div class="row justify-content-between">
              <div class="col-md-6 text-left">
                <div
                  v-if="errors.has('custom-document.matter')"
                  class="con-text-validation span-text-validation-danger v-enter-to"
                >
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.matter') }}
                  </span>
                </div>
              </div>
              <div class="col-md-6 text-right">
                <small v-tooltip="'Contador de caracteres'">
                  {{formData.matter.length}}/500
                </small>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <b-form-group label="Descripción *">
            <editor-text
              :danger="errors.has('custom-document.description')"
              :danger-text="errors.first('custom-document.description')"
              data-cy="description"
              data-vv-as="descripción"
              :max-length="maxLengthDescription"
              name="description"
              ref="description"
              v-validate="'required'"
              v-model="formData.description"
              with-counter
            />
          </b-form-group>
        </div>
        <div class="col-md-6 mt-2">
          Orientación de documento
          <div class="row mt-3">
            <div class="col-md-4">
              <vs-radio
                vs-name="portrait"
                vs-value="Portrait"
                v-model="formData.orientation"
                data-cy="portrait"
              >
                Vertical
              </vs-radio>
            </div>
            <div class="col-md-4">
              <vs-radio
                vs-name="landscape"
                vs-value="Landscape"
                v-model="formData.orientation"
                data-cy="landscape"
              >
                Horizontal
              </vs-radio>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row align-items-center mt-5">
            <div class="col-md-12">
              <label>Adjuntos</label>
            </div>
            <div class="col-md-3 align-items-end">
              <UploadFile
                permission="*"
                accept="application/pdf, .doc, .docx, .xlsx, .ppt"
                text="Seleccionar documentos"
                v-model="fileOthers"
                upload-to="ed"
                :button-class="{ 'btn-block': true,
                 'mb-5': errors.has('custom-document.fileName') }"
                container-class="w-100"
                @input="addOthersFile()"
              />
            </div>
          </div>
          <div class="row align-items-center mt-1">
            <div class="col-md-3 align-items-end">
              <b-button
                variant="secondary"
                class="btn-icon mt-1"
                data-cy= "from-repository"
                v-has-permission="'ED060'"
                v-b-modal="'add-file-repository'"
              >
                <feather-icon icon="ServerIcon"/>
                Desde el repositorio
              </b-button>
            </div>
            <div class="col-2" v-for="file in formData.attachments" :key="file.id">
              <div class="d-flex flex-column align-items-center">
                <vs-icon icon="description" size="45px" color="primary" />
                <b class="text-truncate w-100 text-center">{{ file.name }}</b>
                <vs-button
                  color="danger"
                  type="flat"
                  icon="clear"
                  @click="removeOthersFile(file.id)"
                />
              </div>
            </div>
          </div>
          <div
            v-if="!!error.messageOthers"
            class="con-text-validation span-text-validation-danger
          vs-input--text-validation-span v-enter-to text-left"
          >
            <span class="span-text-validation">
              {{ error.messageOthers }}
            </span>
          </div>
        </div>
      </div>
      <div class="row justify-end">
        <vs-button
          class="mt-5 mr-5"
          data-cy="cancel"
          @click="back()"
          color="primary"
          :disabled="saving"
        >
          Cancelar
        </vs-button>
        <vs-button
          class="mt-5 mr-5"
          data-cy="save"
          @click="save()"
          color="success"
          :disabled="saving"
        >
          Crear
          <span
            v-show="saving"
            class="spinner-border spinner-border-sm text-primary"
          />
        </vs-button>
      </div>
      <!--<SelectDocRepository
        :add-file="addFileRepo"
        :files="formData.attachments"
        :remove-file="removeOthersFile"
      />-->
      <repository-selector
        modal-id="add-file-repository"
        :add-file="addFileRepo"
        :files="formData.attachments"
        :remove-file="removeOthersFile"
      />
    </form>
  </div>
</template>
<script>

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import FindCodeGroupMixin
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/FindCodeGroupMixin';
import EditorText from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import SelectDocRepository
from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/SelectDocRepository';
import RepositorySelector from "@/febos/global/customDocuments/components/repository-selector/RepositorySelector.vue";

export default {
  name: 'OFCORE',
  components: {RepositorySelector, SelectDocRepository, UploadFile, EditorText },
  mixins: [FindCodeGroupMixin],
  data() {
    return {
      error: {
        messageOthers: ''
      },
      formData: {
        sender: 'SECRETARIO EJECUTIVO CONSEJO REGIONAL VALPARAÍSO',
        receiver: '',
        matter: '',
        background: '',
        orientation: 'Portrait',
        description: '',
        attachments: []
      },
      fileOthers: {},
      saving: false,
      maxLengthDescription: 100000
    };
  },
  methods: {
    async addFileRepo(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.formData.attachments.push(file);
      this.error.message = '';
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.attachments.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) {
        return;
      }

      const textPlainDescription = this.$refs.description.getTextPlain();

      if (textPlainDescription.length > this.maxLengthDescription) {
        this.$bvToast.toast(
          'El campo descripción tiene más caracteres de los permitidos',
          {
            title: '¡Oops!',
            variant: 'danger',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      this.saving = true;
      this.$bvToast.toast(
        'Guardando documento',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      const codeGroup = await this.findCodeGroup();
      const payload = {
        type: this.$route.params.type,
        query: this.$route.query,
        formData: {
          ...this.formData,
          textPlainDescription,
          codeGroup,
          metadata: { orientation: this.formData.orientation }
        }
      };
      const response = await ioCreateCustomDocument(payload);
      await this.generatePdf(response.data.document.id);
      this.saving = false;
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('OFCORE', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    }
  }
};
</script>
